// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:26dc2b57-2d54-4bf7-8fd1-49f8379a7a71",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_TDpLCpZWq",
    "aws_user_pools_web_client_id": "4ja1r81jg9dmjcjlnf5lkol73s",
    "oauth": {},
    "Auth": {

      // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
      identityPoolId: 'XX-XXXX-X:XXXXXXXX-XXXX-1234-abcd-1234567890ab',
      
      // REQUIRED - Amazon Cognito Region
      region: 'us-west-2',

      // OPTIONAL - Amazon Cognito User Pool ID
      userPoolId: 'us-west-2_yT2zkxy5n',

      // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
      userPoolWebClientId: '1oru9r4k6jq39a2c5ajd2somm7',
 
      // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
      mandatorySignIn: false,
      
      // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
      authenticationFlowType: 'USER_PASSWORD_AUTH'
  }

};


export default awsmobile;
